import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'lib-static-dynamic-table',
  templateUrl: './static-dynamic-table.component.html',
  styleUrls: ['./static-dynamic-table.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaticDynamicTableComponent {
  @Input() columns: any[] = [];
  @Input() rows: any[] = [];
  @Input() tableHeight: any = '36em';
  @Input() listItems: string[] = ['Delete'];
  @Output() railGroupClick = new EventEmitter<any>();
  @Output() actionEvent = new EventEmitter<{
    name: string;
    row: any;
    rowIndex: number;
  }>();

  onRowClick(name, groupName) {
    this.railGroupClick.emit({ name, groupName });
  }

  onActionMenu(event: any, row: any, index: number): void {
    this.actionEvent.emit({ name: event?.detail, row, rowIndex: index });
  }
}
